import React from 'react';
import ThumbNailContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/Thumbnail';
import Thumbnail from '../Components/Thumbnail';

export default (props) => (
  <ThumbNailContainer
    Component={Thumbnail}
    {...props}
  />
);
